import React from 'react'
import { AppCrudTable } from '@components'
import { useTableData } from 'Pages/Admin/GroupedExports/@hooks'
import { isLoadingTable } from 'Pages/Admin/GroupedExports/@signals'
import { Skeleton } from '@mui/material'
import { createdColumn, exportedColumn, filenameColumn, infoColumn, timestampExportColumn, userColumn } from 'Pages/Admin/GroupedExports/Table/@columns'
import GroupedExportsTableToolbar from 'Pages/Admin/GroupedExports/Table/Toolbar'


export default function GroupedExportsTable({ isExtra }) {

	const data = useTableData(isExtra)

	if (isLoadingTable.value) return <Skeleton variant="rectangular" height={400}/>

	return <AppCrudTable
		title="Export Groups"
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <GroupedExportsTableToolbar
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>,
		}}
		columns={[ userColumn(), filenameColumn(), ...createdColumn(), ...timestampExportColumn(), ...exportedColumn(), infoColumn() ]}
		data={data}
	/>
}